export default "__VITE_ASSET__DtHR9xI0__"